(function ($, SCS, debug) {
	'use strict';

	var zeroFill = require('lib/util/helpers').zeroFill;
	/**
	 * Create namespace
	 */
	SCS.TV = SCS.TV || {};


	/********************
	 * Public API
	 *
	 * All methods that need to request data via ajax offer a callback function and also
	 * return a jQuery-Deferred object (read more here: http://api.jquery.com/category/deferred-object/)
	 ********************/

	/**
	 * load one broadcast by id
	 */
	SCS.TV.getBroadcastById = function (id, callback) {
		var def = $.Deferred();
		new SCS.TV.Broadcast(id, function(broadcast) {
			def.resolve(broadcast);
			if (typeof callback === 'function') {
				callback(broadcast);
			}
		});
		return def;
	};

	/**
	 * load multiple broadcasts at once
	 * use this instead of multiple times getBroadcastById, as this method only needs one ajax call for all the give broadcastids
	 */
	SCS.TV.getMultipleBroadcastsById = function (broadcastIds, callback) {
		var def = $.Deferred();
		if (broadcastIds && broadcastIds.length > 0) {

			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/tv/broadcasts/list/(datalevel=normal;ids=' + broadcastIds.join(',') + ');', function (data) {
				var broadcasts = [];

				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					for (var i = 0; i < data.Nodes.Items.length; i++) {
						if (data.Nodes.Items[i] && data.Nodes.Items[i].Kind === 'Broadcast') {
							var tempBroadcast = new SCS.TV.Broadcast();
							tempBroadcast._readData(data.Nodes.Items[i]);

							broadcasts.push(tempBroadcast);
						}
					}
				}

				// service does not return content in the same order as requested.. so sort it again
				broadcasts = SCS.TV.Helper.orderByArrayOrder(broadcastIds, broadcasts, 'broadcastId');

				def.resolve(broadcasts);
				if (typeof callback === 'function') {
					callback(broadcasts);
				}
			});
		}
		else {
			def.resolve([]); // we do not use def.reject(); as otherwise we would need to handle the exception in every usage
		}
		return def;
	};

	/**
	 * load multiple channels at once
	 */
	SCS.TV.getMultipleChannelsById = function (channelIds, callback) {
		var def = $.Deferred();
		if (channelIds && channelIds.length > 0) {

			var ids = channelIds.join(',');
			if(ids.length > 0){
				$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/tv/channels/list/(ids=' + ids + ');', function (data) {
					var channels = [];

					if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
						for (var i = 0; i < data.Nodes.Items.length; i++) {
							if (data.Nodes.Items[i] && data.Nodes.Items[i].Kind === 'Channel') {
								debug.log('SCS.TV.getMultipleChannelsById', data.Nodes.Items[i]);
								var tempChannel = new SCS.TV.Channel();
								tempChannel._readData(data.Nodes.Items[i]);
								channels.push(tempChannel);
							}
						}
					}

					// service does not return content in the same order as requested.. so sort it again
					channels = SCS.TV.Helper.orderByArrayOrder(channelIds, channels, 'channelId');

					def.resolve(channels);
					if (typeof callback === 'function') {
						callback(channels);
					}
				});
			}
		}
		else {
			def.resolve([]); // we do not use def.reject(); as otherwise we would need to handle the exception in every usage
		}
		return def;
	};

	/**
	 * load multiple movies at once
	 */
	SCS.TV.getMultipleMoviesById = function(movieIds, callback) {
		debug.log('SCS.TV.getMultipleMoviesById > movieIds', movieIds);
		var def = $.Deferred();

		if (movieIds && movieIds.length > 0) {

			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/vod/' + SCS.Const.SNOOPY_VOD_STORES[SCS.Const.SNOOPY_LANGUAGE] + '/movies/list/(datalevel=normal;ids=' + movieIds + ');', function (data) {
				var movies = [];
				debug.log('SCS.TV.getMultipleMoviesById > data', data);
				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					for (var i = 0; i < data.Nodes.Items.length; i++) {

						var tempMovie = new SCS.TV.Movie();
						tempMovie._readData(data.Nodes.Items[i]);
						movies.push(tempMovie);

					}
				}

				// service does not return content in the same order as requested.. so sort it again
				movies = SCS.TV.Helper.orderByArrayOrder(movieIds, movies, 'movieId');

				def.resolve(movies);
				if (typeof callback === 'function') {
					callback(movies);
				}
			});
		}
		else {
			def.resolve([]); // we do not use def.reject(); as otherwise we would need to handle the exception in every usage
		}
		return def;
	};

	/**
	 * Loads movie highlights - first selects "RecentlyAdded"-Category and then selects element of this category
	 **/
	SCS.TV.getMovieHighlights = function (callback, limit) {
		var def = $.Deferred(),
			limitStr = limit ? ';limit=' + limit : '';

		// first load all categories
		$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/vod/' + SCS.Const.SNOOPY_VOD_STORES[SCS.Const.SNOOPY_LANGUAGE] + '/categories/list/(ids=all;level=minimal);', function (data) {
			if (!(data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0)) {
				def.resolve([]);
				if (typeof callback === 'function') {
					callback([]);
				}
				return [];
			}

			var categoryData = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(data.Nodes.Items, 'Container', 'RecentlyAdded');
			if (!categoryData) {
				def.resolve([]);
				if (typeof callback === 'function') {
					callback([]);
				}
				return [];
			}

			// if a "RecenlyAdded" category has been found - request content of this category
			var categoryId = categoryData.Identifier;
			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/vod/' + SCS.Const.SNOOPY_VOD_STORES[SCS.Const.SNOOPY_LANGUAGE] + '/categories/detail/(ids=' + categoryId + ';level=normal' + limitStr + ');', function (vodData) {

				var movies = [];

				if (vodData && vodData.Nodes && vodData.Nodes.Items && vodData.Nodes.Items.length === 1 && vodData.Nodes.Items[0].Content && vodData.Nodes.Items[0].Content.Nodes && vodData.Nodes.Items[0].Content.Nodes.Items && vodData.Nodes.Items[0].Content.Nodes.Items.length > 0) { // item = selected category
					var categoryContent = vodData.Nodes.Items[0].Content.Nodes.Items;
					for (var i = 0; i < categoryContent.length; i++) {

						// for each VOD - check if there is a web-version and a poster image, then add to list
						if (categoryContent[i].Content && categoryContent[i].Content.Nodes && categoryContent[i].Content.Nodes.Items && categoryContent[i].Content.Nodes.Items.length > 0) {

							var webVersion = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(categoryContent[i].Content.Nodes.Items, 'Asset', undefined, 'WEB');
							if (webVersion) { // web version exists
								var posterImage = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(categoryContent[i].Content.Nodes.Items, 'Image', 'Poster');
								if (posterImage) { // poster image available
									var tempMovie = new SCS.TV.Movie();
									tempMovie._readData(categoryContent[i]);
									movies.push(tempMovie);
								}
							}
						}
					}
				}
				def.resolve(movies);
				if (typeof callback === 'function') {
					callback(movies);
				}
			});
		});
		return def;
	};

	/**
	 * Loads most rented movies
	 **/
	SCS.TV.getMostRentedMovies = function (callback, limit) {
		$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'discovery/generallist/vod/mostrented/?language=' + SCS.Const.SNOOPY_LANGUAGE, function (vodData) {
			var movies = [];

			if (vodData && vodData.Nodes && vodData.Nodes.Items && vodData.Nodes.Items.length === 1 && vodData.Nodes.Items[0].Content && vodData.Nodes.Items[0].Content.Nodes && vodData.Nodes.Items[0].Content.Nodes.Items && vodData.Nodes.Items[0].Content.Nodes.Items.length > 0) { // item = selected category
				var vodContent = vodData.Nodes.Items[0].Content.Nodes.Items;

				for (var i = 0; i < vodContent.length && (!limit || i < limit); i++) {
					// for each VOD - check if there is a web-version and a poster image, then add to list
					if (vodContent[i].Content && vodContent[i].Content.Nodes && vodContent[i].Content.Nodes.Items && vodContent[i].Content.Nodes.Items.length > 0) {
						var posterImage = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(vodContent[i].Content.Nodes.Items, 'Image', 'Poster');

						if (posterImage) { // poster image available
							var tempMovie = new SCS.TV.Movie();

							tempMovie._readData(vodContent[i]);
							movies.push(tempMovie);
						}
					}
				}
			}

			if (typeof callback === 'function') {
				callback(movies);
			}
		});
	}

	/**
	 * load one sport-event by id
	 */
	SCS.TV.getSportEventById = function (id, callback) {
		var def = $.Deferred();
		new SCS.TV.SportEvent(id, function(sportEvent) {
			def.resolve(sportEvent);
			if (typeof callback === 'function') {
				callback(sportEvent);
			}
		});
		return def;
	};

	/**
	 * load multiple sportevents at once
	 * use this instead of multiple times getSportEventById, as this method only needs one ajax call for all the give broadcastids
	 */
	SCS.TV.getMultipleSportEventsById = function (sportEventIds, callback) {
		var def = $.Deferred();
		if (sportEventIds && sportEventIds.length > 0) {

			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/sport/' + SCS.Const.SNOOPY_LANGUAGE + '/events/list/(ids=' + sportEventIds.join(',') + ');', function (data) {
				var sportEvents = [];

				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					for (var i = 0; i < data.Nodes.Items.length; i++) {
						if (data.Nodes.Items[i]) {
							var tempSportEvent = new SCS.TV.SportEvent();
							tempSportEvent._readData(data.Nodes.Items[i]);

							sportEvents.push(tempSportEvent);
						}
					}
				}

				// service does not return content in the same order as requested.. so sort it again
				sportEvents = SCS.TV.Helper.orderByArrayOrder(sportEventIds, sportEvents, 'sportEventId');

				def.resolve(sportEvents);
				if (typeof callback === 'function') {
					callback(sportEvents);
				}
			});
		}
		else {
			def.resolve([]); // we do not use def.reject(); as otherwise we would need to handle the exception in every usage
		}
		return def;
	};


	/**
	 * Selects movie highlights from categories saved in tvHighlightsCategories
	 * ISSUE: Does not return channel-name (and also channel-id is not returned with datalevel=minimal) therefore channelname cannot be used as alt-text of logo
	 */
	SCS.TV.getTvHighlights = function (callback, dateFrom, dateTo, limit) {
		var def = $.Deferred(),
			limitStr = limit ? ';limit=' + (limit*2) : ''; // load two times as many items as needed as often there are dublicates that get filtered out
		if (!dateFrom) {
			dateFrom = new Date();
		}
		if (!dateTo) {
			dateTo = new Date(dateFrom.getTime() + 24 * 60 * 60 * 1000);
		}

		dateFrom.setMinutes(Math.floor(dateFrom.getMinutes()/10)*10); // round to 10min - better caching
		dateTo.setMinutes(Math.floor(dateTo.getMinutes()/10)*10);

		var dateFromFilter = dateFrom.getFullYear().toString() + zeroFill(dateFrom.getMonth() + 1) + zeroFill(dateFrom.getDate()) + zeroFill(dateFrom.getHours()) + zeroFill(dateFrom.getMinutes());
		var dateToFilter = dateTo.getFullYear().toString() + zeroFill(dateTo.getMonth() + 1) + zeroFill(dateTo.getDate()) + zeroFill(dateTo.getHours()) + zeroFill(dateTo.getMinutes());

		$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/tv/' + SCS.Const.SNOOPY_LANGUAGE + '/categories/detail/(datalevel=reduced;end=' + dateToFilter + ';ids=' + SCS.Const.SNOOPY_TV_HIGHLIGHTS_CATEGORIES[SCS.Const.SNOOPY_LANGUAGE] + ';start=' + dateFromFilter + limitStr + ')', function (data) {
			var broadcasts = [];

			if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length === 1 && data.Nodes.Items[0].Content && data.Nodes.Items[0].Content.Nodes && data.Nodes.Items[0].Content.Nodes.Items && data.Nodes.Items[0].Content.Nodes.Items.length > 0) { // item = selected category
				var categoryContent = data.Nodes.Items[0].Content.Nodes.Items;
				for (var i = 0; i < categoryContent.length; i++) {

					// for each VOD - check if there is a web-version and a poster image, then add to list
					if (categoryContent[i].Content && categoryContent[i].Content.Nodes && categoryContent[i].Content.Nodes.Items && categoryContent[i].Content.Nodes.Items.length > 0) {

						var posterImage = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(categoryContent[i].Content.Nodes.Items, 'Image', 'Poster');
						if (posterImage) { // poster image available
							var tempBroadcast = new SCS.TV.Broadcast();
							tempBroadcast._readData(categoryContent[i]);
							broadcasts.push(tempBroadcast);
						}
					}
				}
			}

			// filter double entries
			broadcasts = SCS.TV.Helper.removeDuplicateTitles(broadcasts);
			if (limit) {
				broadcasts = broadcasts.slice(0, limit);
			}

			def.resolve(broadcasts);
			if (typeof callback === 'function') {
				callback(broadcasts);
			}
		});
		return def;
	};

}(window.jQuery, window.SCS = window.SCS || {}, window.debug));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.js
// module id = 87
// module chunks = 0